export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: "الموقع الإلكتروني",
    introCreated: "تم إنشاء موقعك الإلكتروني بالفعل. ادخل لتعديله متى شئت.",
    introEmpty:
      "أنشئ الموقع الإلكتروني لمكان إقامتك، مع تقويمك بداخله. تُعدّله بالسحب والإفلات، دون كتابة أي كود.",
    emptyTitle: "ليس لديك موقع إلكتروني بعد",
    emptyBody:
      "تختار قالبًا من قطاعك، وتغيّر الصور والنصوص، ويصبح لديك موقع إلكتروني قابل للنشر. يبقى محرّك البحث عن التواريخ متصلًا بتقويمك.",
    creating: "جارٍ الإنشاء…",
    createCta: "إنشاء موقعي",
    createAnother: "إنشاء موقع آخر",
    collapse: "طي",
    expand: "عرض التفاصيل",
    limitReached: "تسمح باقتك بـ {n} موقع/مواقع.",
    lockedTitle: "موقعك الإلكتروني متاح مع باقة Suite",
    lockedBody:
      "لإنشاء موقع مكان إقامتك وإدارته مع WACheckin، يجب أن تكون باقة Suite مفعّلة لديك.",
    lockedCta: "عرض باقة Suite",
    nameLabel: "اسم موقعك الإلكتروني",
    viewWeb: "عرض الموقع",
    opening: "جارٍ الفتح…",
    editCta: "تعديل صفحتي",
    noPublicAddress: "ليس له عنوان عام بعد",
    published: "منشور",
    unpublished: "غير منشور",
    visibleToPublic: "مرئي للعامة",
    addressTitle: "عنوان موقعك الإلكتروني",
    addressSubtitle: "اختر العنوان الذي تريد أن يراه ضيوفك عليه.",
    modeWacheckin: "استخدم عنوان WACheckin",
    modeWacheckinHint: "مجاني وجاهز فورًا",
    modeOwn: "استخدم نطاقك الخاص",
    modeOwnHint: "إذا كان لديك واحد بالفعل",
    subdomainLabel: "الكلمة التي تأتي في المقدمة",
    subdomainPlaceholder: "your-accommodation-name",
    saving: "جارٍ الحفظ…",
    save: "حفظ",
    subdomainPreview: "سيكون موقعك على",
    subdomainFree: "اكتبها كما تشاء: نحوّلها إلى عنوان صالح.",
    otherDomainNote:
      "لديك أيضًا {dominio} متصل. سيظل هذا العنوان يعمل وسيؤدي إلى الموقع نفسه.",
    noDomainYet: "لم تحدّد بعد النطاق الذي تريده",
    continueConnection: "متابعة الربط",
    connectDomain: "ربط نطاقي",
    searchTitle: "أماكن الإقامة التي يمكن لمحرّك البحث عرضها",
    searchSubtitle: "ما تحدّده هنا هو ما سيراه ضيوفك عند البحث عن التواريخ.",
    missingPhotosLabel: "لا توجد صور بعد:",
    missingPhotosHelp:
      "ارفعها من الحجوزات المباشرة → الصور وستظهر هنا. لا يلزم أن تكون معروضة للبيع.",
    previewError: "تعذّر تحميل المعاينة.",
    previewRetry: "إعادة المحاولة",
    deleteExplain: "يحذف الموقع وكل ما فيه. لا يمكن التراجع.",
    deleteTitle: "حذف «{nombre}»؟",
    deleteBody: "لا يمكن التراجع عن هذا. إن أردت إخفاءه فقط، أطفئ «ظاهر للعموم» ويبقى الموقع محفوظًا.",
    deleteItemPages: "صفحاته الـ {n} بنصوصها وتصميمها",
    deleteItemAddress: "العنوان الذي يظهر عليه الآن",
    deleteItemMessages: "الرسائل التي وصلتك من نماذجه",
    deleteCancel: "إلغاء",
    deleteConfirm: "نعم، احذف",
    deleting: "جارٍ الحذف…",
    previewTitle: "موقعك الآن",
    previewDesktop: "حاسوب",
    previewMobile: "هاتف",
    previewLoading: "جارٍ تحميل موقعك…",
    previewNote: "هكذا يبدو بآخر تغييراتك المحفوظة. يرى ضيوفك آخر نسخة نشرتها.",
    footerNote:
      "في الوقت الحالي لكل حساب موقع واحد. راسلنا إذا كنت بحاجة إلى المزيد.",
    deleteWeb: "حذف هذا الموقع",
    mensajes: {
      title: "رسائل موقعك",
      subtitle: "ما يكتبه الزوار في نماذج موقعك. تصلك كل رسالة أيضًا عبر البريد الإلكتروني.",
      inbox: "الوارد",
      archived: "المؤرشفة",
      unread: "{n} غير مقروءة",
      empty: "لم يراسلك أحد بعد. عندما يملأ أحدهم نموذجًا في موقعك ستراه هنا وسيصلك عبر البريد الإلكتروني.",
      emptyArchived: "لا توجد لديك رسائل مؤرشفة.",
      loadError: "تعذّر تحميل الرسائل.",
      retry: "إعادة المحاولة",
      reply: "الرد عبر البريد الإلكتروني",
      whatsapp: "واتساب",
      call: "اتصال",
      markRead: "تعليم كمقروءة",
      markUnread: "تعليم كغير مقروءة",
      archive: "أرشفة",
      unarchive: "إعادة إلى الوارد",
      delete: "حذف",
      confirmDelete: "هل تريد حذف هذه الرسالة؟ لا يمكن التراجع عن ذلك.",
      confirmYes: "نعم، احذف",
      confirmNo: "لا",
      form: "النموذج",
      from: "من",
      more: "عرض المزيد",
      anonymous: "بدون اسم",
      replySubject: "رسالتك في {sitio}",
      notSent: "لم يُرسل تنبيه البريد الإلكتروني بعد.",
      errorAction: "تعذّر حفظ التغيير. حاول مرة أخرى.",
    },
    loadingAccommodations: "جارٍ تحميل أماكن إقامتك…",
    noPhotosYet:
      "لا يوجد لدى أي من أماكن إقامتك صور بعد. ارفعها من الحجوزات المباشرة → الصور وستتمكّن من عرضها هنا.",
    noAccommodations: "لم تنشئ أي أماكن إقامة بعد.",
    loadError: "تعذّر تحميل صفحاتك.",
    defaultSiteName: "مكان إقامتي",
    createError: "تعذّر إنشاء الصفحة.",
    saveError: "تعذّر الحفظ.",
    subdomainTooLong: "أصبح طويلًا جدًا.",
    subdomainReserved: "هذه الكلمة محجوزة. جرّب كلمة أخرى.",
    addressSaved: "تم حفظ العنوان.",
    subdomainChecking: "نتحقّق مما إذا كان متاحًا…",
    subdomainAvailable: "متاح. سيكون موقعك على",
    subdomainChangeWarning: "عند الحفظ، سيتوقف العنوان الحالي عن العمل.",
    subdomainTaken: "هذا العنوان يستخدمه موقع آخر بالفعل.",
    subdomainTryThis: "هذا متاح:",
    subdomainUse: "استخدم هذا",
    subdomainGeneric: "لا يقول شيئًا عن مكان إقامتك. نقترح:",
    subdomainProposal: "نقترح عنوانًا باسم مكان إقامتك:",
    domainHelpEmpty:
      "نرشدك خطوة بخطوة: تكتب النطاق، وتنسخ سطرين في لوحة المكان الذي اشتريته منه، ونتحقّق منه نحن.",
    domainHelpPending:
      "تنقص السجلات في لوحة نطاقك، أو أنها لم تصل بعد إلى كل مكان. ادخل ونتحقّق منه.",
    popupBlocked: "اسمح بالنوافذ المنبثقة لفتح المحرّر.",
    editorError: "تعذّر فتح المحرّر.",
    confirmDelete: `حذف « {nombre} »؟ سيتوقف الموقع عن الظهور.`,
    deleteError: "تعذّر الحذف.",
  },

  selectOta: {
    lockBadge: "ميزة اشتراك",
    lockTitle: "اربط قنوات OTA لديك بخطة نشطة",
    lockText:
      "لمزامنة <b>Booking, Airbnb, Vrbo, Expedia</b> والمزيد من القنوات مع WA&nbsp;Checkin، عليك الاشتراك في خطة. مع اشتراكك، تقوم Janet بمزامنة الأسعار والتوافر والحجوزات تلقائيًا — دون حجز زائد ودون مهام يدوية.",
    morePreviewTitle: "وأكثر من 100 قناة OTA",
    otasAvailable: "قنوات OTA متاحة",
    lockCta: "عرض الخطط والاشتراك",
    lockFoot: "مزامنة تلقائية · مكافحة الحجز الزائد · دعم الربط مشمول",
    connectOtaTitle: "ربط قناة OTA",
    googleFaltan: "ينقص بيانات مكان إقامتك شيء واحد لجوجل | تنقص بيانات مكان إقامتك {count} أشياء لجوجل",
    googlePreparar: "تجهيزها",
    beta: "تجريبي",
    pctChipTitle: "نسبة التعرفة المشتقّة لهذه القناة OTA",
    comingSoon: "قريبًا",
    manage: "إدارة",
    connectNow: "اربط الآن",
    pctModalTitle: "نسبة التعرفة",
    pctModalHint:
      "ما النسبة الإضافية (أو الأقل) التي ستحصّلها من ضيوفك إذا حجزوا عبر <b>{ota}</b>؟ استخدم <b>+</b> لتحصيل المزيد أو <b>−</b> لتحصيل أقل (مثال: <b>15.5</b> أو <b>−10</b>).",
    thisOta: "هذه القناة OTA",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    save: "حفظ",
    exploreMore: "استكشف أكثر من 100 قناة OTA متاحة",
    activeConnections: "الاتصالات النشطة",
    searchPlaceholder: "بحث...",
    loadingConnections: "جارٍ تحميل الاتصالات...",
    thChannel: "القناة",
    thConnectionId: "معرّف الاتصال",
    thLastSync: "آخر مزامنة",
    thActions: "الإجراءات",
    copied: "تم النسخ!",
    copyId: "نسخ المعرّف",
    contactTitle: "اتصل بـ {name}",
    contactDescription:
      "اربط حساب {name} الخاص بك بمنصتنا بسهولة لتسريع تجربتك. اتّبع الخطوات أدناه لإكمال العملية.",
    step1Title: "أنشئ حساب {name}",
    step1Description:
      "إذا لم يكن لديك حساب {name} بعد، فستحتاج أولًا إلى إنشاء واحد.",
    createAccountLink: "إنشاء حساب →",
    step1Hint: "هل لديك حساب بالفعل؟ انتقل إلى الخطوة 2.",
    step2Title: "التواصل مع فريق الدعم",
    step2Description:
      "بمجرد أن يصبح حساب {name} جاهزًا، سيساعدك فريقنا على ربطه.",
    contactSupportLink: "التواصل مع فريق الدعم →",
    connectDirectNoSupport: "الربط مباشرةً (دون دعم) →",
    step2Hint: "يُنصح به فقط إذا كنت تعرف ما ستقوم بإعداده في Channex.",
    connectDirectly: "الربط مباشرةً",
    iframeTitle: "الربط مع {channel}",
    iframeSubtitle: "اتصال آمن يديره channel manager",
    close: "إغلاق",
    iframeLoading: "جارٍ فتح الاتصال الآمن…",
    actionRequired: "إجراء مطلوب",
    viewPlans: "عرض الخطط",
    descBooking: "اصل إلى المسافرين لأغراض العمل والترفيه في جميع أنحاء العالم",
    descAirbnb: "اربط عقارك بملايين المسافرين على Airbnb",
    descVrbo: "متخصص في الإيجارات لقضاء العطلات للعائلات",
    descExpedia: "شبكة سفر عالمية مع ملايين المستخدمين النشطين",
    descBnb: "بوابة إيطالية لبيوت الضيافة (B&B) وأماكن الإقامة الساحرة",
    descGvr: "اظهر مجانًا في نتائج Google Maps وعمليات البحث",
    descAgoda: "اجذب مسافرين من آسيا ومن بقية أنحاء العالم",
    descHotelbeds: "غرف لوكالات السفر ومنظمي الرحلات في جميع أنحاء العالم",
    savePercentError: "تعذّر حفظ النسبة. يُرجى المحاولة مرة أخرى.",
    channelGeneric: "قناة",
    statusInactive: "غير نشط",
    statusConnected: "متصل",
    statusSyncing: "جارٍ المزامنة",
    webReservationsName: "الحجوزات المباشرة عبر الويب",
  },

  connectionChannel: {
    errorTitle: "خطأ",
    successTitle: "تم بنجاح",
    connectionDisabled: "الاتصال معطّل",
    syncError: "خطأ أثناء المزامنة",
    loadPropertiesError: "خطأ في تحميل العقارات",
    connectionUpdated: "تم تحديث الاتصال {channelName}",
    updateConnError: "خطأ في تحديث الاتصال: {detail}",
    unknownError: "خطأ غير معروف",
    connectionWith: "الاتصال مع {channelName} {status}",
    stateUpdatedTitle: "تم تحديث الحالة",
    confirmDeleteMessage:
      "هل أنت متأكد من أنك تريد حذف هذا الاتصال؟ سيؤدي ذلك أيضًا إلى حذف العقارات والحجوزات المرتبطة به.",
    confirmDeleteHeader: "تأكيد الحذف",
    deleteConnection: "حذف الاتصال",
    no: "لا",
    connectionDeleted: "تم حذف الاتصال بنجاح",
    deleteConnError: "خطأ في حذف الاتصال: {detail}",
    webhookCopied: "تم نسخ الـ Webhook إلى الحافظة",
    webhookCopyError: "خطأ في نسخ الـ Webhook",
    title: "قناة الاتصال (PMS)",
    description:
      "في هذا القسم يمكنك الاتصال بأنظمة إدارة العقارات (PMS) لإجراء الاستعلامات والإدارة وتحديث المعلومات بكفاءة ودون أخطاء.",
    connectedAccount: "الحساب المتصل",
    switchTooltip:
      "إيقاف أو تفعيل الخدمة التي تستقبل الحجوزات تلقائيًا في النظام.",
    syncing: "جارٍ المزامنة...",
    sync: "مزامنة",
    deleting: "جارٍ الحذف...",
    webhookLabel: "WEBHOOK:",
    webhookInfoTooltip:
      "أضف هذا الـ Webhook إلى حساب Smoobu الخاص بك لاستقبال الحجوزات المنشأة في نظام PMS تلقائيًا",
    copyToClipboard: "نسخ إلى الحافظة",
    syncedProperties: "العقارات المتزامنة",
    noAddress: "بدون عنوان",
    noSyncedProperties: "لا توجد عقارات متزامنة",
  },

  wabaIntegration: {
    activationInProgress: "التفعيل قيد التنفيذ",
    pendingBody:
      "نقوم بتفعيل WhatsApp الخاص بشركتك. بينما تعتمد Meta قوالبك (يستغرق ذلك عادةً حتى 24&nbsp;ساعة) وتتحقّق من رقمك، تُرسَل رسائلك عبر <strong>WhatsApp الخاص بـ WACheckin</strong> كي لا تتوقف عن التواصل مع ضيوفك. سيتحوّل إلى رقمك الخاص <strong>تلقائيًا</strong> بمجرد أن يصبح جاهزًا — لا عليك فعل أي شيء.",
    phoneStatusHeading: "حالة رقم WhatsApp",
    numberLabel: "الرقم:",
    virtualNumberNote:
      "هذا <strong>رقم افتراضي مقدَّم من Meta</strong>. لا يستقبل مكالمات أو رسائل SMS عادية، بل رسائل WhatsApp فقط عبر الـ API.",
    statusLabel: "الحالة:",
    templatesStatusHeading: "حالة القوالب",
    canSend:
      "رقمك <strong>متصل ومُتحقَّق منه</strong> ولديك قالب واحد معتمد على الأقل. يمكنك الآن إرسال الرسائل.",
    cannotSendYet:
      "<strong>لا يمكنك إرسال الرسائل بعد</strong>. انتظر حتى تعتمد Meta رقم الهاتف والقوالب.",
    virtualPendingNote:
      "ضع في اعتبارك أنه إذا لم يكن نشاطك التجاري على Meta موثَّقًا، فقد تظل الأرقام الافتراضية في حالة <strong>قيد الانتظار</strong> ولا تسمح بالإرسال.",
    statusConnectedVerified: "متصل ومُتحقَّق منه",
    statusConnectedPending: "متصل، في انتظار التحقق",
    statusPendingApproval: "في انتظار الموافقة",
    statusDisconnected: "غير متصل",
    statusUnknown: "غير معروف",
  },
};
